export default __webpack_public_path__ + "assets/images/f8b6ee93f3c6874834bea1557d0b1404.png";